import QuantityComponent from "@continente/vue/components/QuantityComponent";
import store from "@continente/vue/components/store";
import UnitsConversionHelper from "../utilities/UnitsConversionHelper";
import {getProductQtyMap, displayQtyInput, displayConfirmationToast, setCartNotesDisplay} from "../components/cartUtil";
import { parents } from "../utilities/selectorHelper";

/**
 * Initializes the Vue Quantity Component
 * @param {string} selector - the element to be initialized selector
 */
const initVueQuantityComponent = (selector, selectedUnit = null) => {
    // Stores the Products Map
    if (!store.state.productMap) {
        store.commit("setProductMap", getProductQtyMap());
    }

    const vues = document.querySelectorAll(selector);
    const vuesArray = Array.from(vues);

    // filter out all hidden inputs from products carousel
    const filteredVues = [...vuesArray].filter(element =>
        parents(element, ".slick-cloned").length == 0
    );

    // filter out all minicart inputs.
    // needed to have quantity input remain on minicart in case if new component is initialized for a same product from a carousel
    const filteredVuesM = Array.from(filteredVues);
    const filteredVuesMinicart = [...filteredVuesM].filter(element =>
        parents(element, ".minicart").length == 0
    );

    const finArray = filteredVuesMinicart.length > 0 ? filteredVuesMinicart : filteredVues;

    Array.from(finArray).forEach(el => {
        const pid = el.dataset.pid;
        let measurementInfo = (el.dataset.measureOptions) ? JSON.parse(el.dataset.measureOptions) : null;
        const isMinicartVisible = selector.includes("minicart");
        const isCartTile = el.closest(".ct-cart-tile") !== null;
        const isQuickViewVisible = el.closest(".js-product-quickview") != null;
        const isHorizontalTile = el.closest(".ct-product-tile-horizontal") != null;
        const isTile = el.closest(".product-tile") !== null;
        const isPDP = el.closest(".product-detail") !== null;
        let previousQuantity = store.getters.getProductInfo(pid, "quantity");

        let currentInputs = "";
        if (selector.includes(".minicart")) {
            currentInputs = document.querySelectorAll(`.minicart .ct-tile-quantity[data-pid="${pid}"]:not(.qv)`);
        } else {
            currentInputs = document.querySelectorAll(`.ct-tile-quantity[data-pid="${pid}"]:not(.qv)`);
        }

        let additionalTag = "";
        let showInput = false;
        let showNotes = false;
        let addToCartBtn;
        let addNotesPDP;
        let isMaster = false;
        let isPriceAvailable = true;
        let checkOnQtyComponent = false;

        // Check if is a minicart input and update
        // elements to avoid conflicts with Tiles, PDP
        if (isMinicartVisible) {
            el.parentElement.classList.add("minicart");
            additionalTag = "minicart";
            showInput = true;
            isMaster = currentInputs.length === 1;
            isPriceAvailable = el.dataset.priceAvailable === "true";
        } else if (isQuickViewVisible) {
            additionalTag = "qv";
            el.parentElement.classList.add(additionalTag, "d-none");
            const getBtn = document.querySelectorAll(`.js-product-quickview .js-add-to-cart-button[data-pid="${pid}"]`);
            addToCartBtn = getBtn.length ? getBtn[0] : null;
            isMaster = document.getElementsByClassName("cart-page").length === 0;
            showInput = true;
            isPriceAvailable = el.dataset.priceAvailable === "true";
        } else if (isCartTile) {
            el.parentElement.classList.add("cart-tile");
            el.parentElement.classList.remove("d-none");
            additionalTag = "cart-tile";
            showInput = true;
            isMaster = true;
        } else if (isTile) {
            additionalTag = "tile";
            el.parentElement.classList.add(additionalTag, "d-none");
            showNotes = isHorizontalTile ? false : true;
            currentInputs = document.querySelectorAll(`.ct-tile-quantity.tile[data-pid="${pid}"]:not(.qv)`);
            isMaster = currentInputs.length === 1;

            if (!isMaster && !isPDP) {
                let duplicatedTile = true;
                currentInputs.forEach(val => {
                    if (val.classList.contains("master")) {
                        duplicatedTile = false;
                        return false;
                    }
                });

                if (duplicatedTile) {
                    el.parentElement.classList.add("master");
                    additionalTag = "-master";
                    isMaster = true;
                }
            }
        } else if (isPDP) {
            const getBtn = document.querySelectorAll(`.js-add-to-cart-button[data-pid="${pid}"]:not([data-outofstock='true'])`);
            addToCartBtn = (getBtn.length) ? getBtn[0] : null;

            el.parentElement.classList.add("pdp-qty-tile");

            if (addToCartBtn) {
                const getNotes = addToCartBtn.parentElement.querySelectorAll(".add-note");
                addNotesPDP = (getNotes.length) ? getNotes[0] : null;
            }

            isMaster = true;
        }

        // Stores the Update URL only if isn't in the stored state yet
        if (!store.state.updateUrl) {
            store.commit("setUpdateUrl", el.dataset.action);
        }

        // Stores the Update URL only if isn't in the stored state yet
        if (!store.state.delayTime) {
            store.commit("setDelayTime", el.dataset.addDelay);
        }

        //Stores the Dimansion update URL only if isnt sored yet
        if (!store.state.dimensionUpdateUrl) {
            store.commit("setDimensionUpdateUrl", el.dataset.dimensionUpdate);
        }

        /**
         * Component data
         */
        const data = () => {
            return {
                displayValue: null,
                prodUnits: null,
                minQtyToDisplay: null,
                maxQtyToDisplay: null,
                isPDP: isPDP && !isTile,
                isQuickViewVisible: isQuickViewVisible,
                pid,
                isMinicartVisible,
                additionalTag,
                showNotes,
                isInvalid: false,
                isMinQtyReached: false,
                isMaxQtyReached: false,
                qtySelectedMoreThanOne: false,
                quantitySelected: 1,
                isPriceAvailable,
                canDisplayMinQtyErrorMsg: document.querySelectorAll(`.product-min-allocation[data-pid="${pid}"]`).length > 0,
                selectedUnit
            };
        };

        /**
         * Component methods
         */
        const methods = {
            /**
             * Creates a product's conversion information
             * @returns - a product's conversion information
             */
            createProductUnitsConversion() {
                const quantity = store.getters.getProductInfo(this.pid, "quantity");

                if (quantity) {
                    let measurementInfo_ = store.getters.getProductMeasure(this.pid);

                    if (measurementInfo_ != null) {
                        measurementInfo = measurementInfo_;
                    }

                    const productConversion = new UnitsConversionHelper(quantity, measurementInfo);
                    store.commit("addProductConversion", {pid: this.pid, productConversion});

                    return productConversion;
                }

                return null;
            },
            /**
             * Initialize the quantity input using a stored product conversion
             * for minicart/tiles to sync with the PDP/PLP pages
             * or create a new one
             */
            initializeQuantityInput() {
                const currentConversion = store.getters.getProductConversion(this.pid);
                let selectedUnit = null;

                if (isMaster && !this.prodUnits) {
                    this.prodUnits = this.createProductUnitsConversion();

                    if (this.prodUnits && !(isPDP && !addToCartBtn) && !isTile) {
                        showInput = true;
                    }
                } else if (currentConversion) {
                    if (isMaster) {
                        this.prodUnits = currentConversion;

                        const quantity = store.getters.getProductInfo(this.pid, "quantity");

                        if (quantity) {
                            let convertValue = false;
                            selectedUnit = this.prodUnits.secondaryUnit;
                            if (this.prodUnits.selectedUnit != this.prodUnits.secondaryUnit) {
                                convertValue = true;
                                selectedUnit = this.prodUnits.selectedUnit;
                            }
                            this.prodUnits.updateValue(quantity, selectedUnit, convertValue);
                        } else if (showInput) {
                            showInput = false;
                        }

                    } else {
                        this.prodUnits = currentConversion;
                    }
                }

                if (this.prodUnits && showInput) {
                    displayQtyInput(this.pid, this.additionalTag);
                    // Hides Add To Cart Button
                    if (addToCartBtn) {
                        addToCartBtn.classList.add("d-none");
                    }
                    // Shows Add Notes Button
                    if (addNotesPDP) {
                        addNotesPDP.classList.remove("d-none");
                    }
                }

                if (this.prodUnits) {
                    let currentUnit = this.selectedUnit ? this.selectedUnit : store.getters.getProductInfo(this.pid, "selectedDimension");
                    if (!currentUnit) {
                        currentUnit = selectedUnit ? selectedUnit : "un";
                    }
                    this.prodUnits.selectedUnit = currentUnit;
                }
                this.minQtyToDisplay = (this.prodUnits && !this.minQtyToDisplay) ? this.prodUnits.minQty : this.minQtyToDisplay;
                this.maxQtyToDisplay = (this.prodUnits && !this.maxQtyToDisplay) ? this.prodUnits.maxQty : this.maxQtyToDisplay;
                this.displayValue = (this.prodUnits) ? this.prodUnits.getFormattedValue() : null;

                let quantityChanged;
                if ((isMinicartVisible || isCartTile) && !checkOnQtyComponent) {
                    quantityChanged = this.maxQtyToDisplay < store.getters.getProductInfo(pid, "quantity");
                    checkOnQtyComponent = true;
                } else {
                    quantityChanged = (previousQuantity && this.maxQtyToDisplay == previousQuantity) || (previousQuantity != store.getters.getProductInfo(pid, "quantity"));
                }

                const eligibleForMaxQtyCheck = quantityChanged && previousQuantity != null;

                this.isMinQtyReached = (this.prodUnits && this.canDisplayMinQtyErrorMsg) ? this.prodUnits.getValue() == this.minQtyToDisplay : false;
                this.isMaxQtyReached = eligibleForMaxQtyCheck ? (this.prodUnits ? (this.maxQtyToDisplay && this.prodUnits.getValue() >= this.maxQtyToDisplay) : false) : false;

                let curentMeasurementInfo = store.getters.getProductMeasure(this.pid);
                if (curentMeasurementInfo && eligibleForMaxQtyCheck) {
                    let quantity = store.getters.getProductInfo(this.pid, "quantity");
                    if (quantity && quantity >= curentMeasurementInfo.maxNumberOfUnitsPerSale) {
                        this.isMaxQtyReached = true;
                        this.$el.querySelector(".error-max-reached")?.remove();
                    } else if (quantity && quantity < curentMeasurementInfo.maxNumberOfUnitsPerSale && quantity > 0.1 && !this.isMaxQtyReached) {
                        this.qtySelectedMoreThanOne = true;
                        this.quantitySelected = this.displayValue;
                    }
                } else if (!this.isMaxQtyReached) {
                    this.qtySelectedMoreThanOne = true;
                    this.quantitySelected = this.displayValue;
                }

                this.isInvalid = this.isMinQtyReached || this.isMaxQtyReached;
                if (isCartTile) setCartNotesDisplay();
                previousQuantity = store.getters.getProductInfo(pid, "quantity");
            },
            /**
             * Handles the confirmation toast
             */
            handleConfirmationToast() {
                if (!this.isMinicartVisible && !(isPDP && isTile && !isMaster) && !isCartTile) {
                    this.$nextTick(() => {
                        displayConfirmationToast(this.$refs[`quantityInput-${this.pid}${this.additionalTag}`], this.displayValue);
                    });
                }
            }
        };

        /**
         * Component mounted function
         */
        const mounted = function () {
            const hasQuantity = store.getters.getProductInfo(this.pid, "quantity");

            if (hasQuantity) {
                this.initializeQuantityInput();
            }

            // Watches the Products Map
            store.watch(() => store.state.productMap, () => {
                this.initializeQuantityInput();
            });

            // Watches the Products Quantity
            store.watch(() => store.getters.getProductInfo(this.pid, "quantity"), (newVal, oldVal) => {
                if (newVal && newVal !== oldVal) {
                    if (oldVal) {
                        this.canDisplayMinQtyErrorMsg = true;
                    }
                    this.handleConfirmationToast();
                }
            }, {deep: true});

            // Watches the Product Selected Unit
            this.$watch("prodUnits.selectedUnit", () => {
                if (this.prodUnits) {
                    this.displayValue = this.prodUnits.getFormattedValue();
                    this.handleConfirmationToast();
                }
            });

            // Watches change of quantity input with value greater than 0 and less than min.
            this.$watch("prodUnits.syncFlag", () => {
                if (this.prodUnits && this.prodUnits.syncFlag && this.prodUnits.syncFlag.pid == this.pid) {
                    if (this.prodUnits.syncFlag.remove) {
                        this.canDisplayMinQtyErrorMsg = false;
                        this.isMinQtyReached = false;
                    } else {
                        this.canDisplayMinQtyErrorMsg = true;
                        this.isMinQtyReached = true;
                    }
                }
            });
        };

        new QuantityComponent({el, store, data, methods, mounted});
    });
};

/**
 * Initializes the Vue Quantity Component for Tiles/PDP
 */
const initProductQuantity = () => initVueQuantityComponent(".product-qty-vue");

/**
 * Initializes the Vue Quantity Component for PDP Variants
 */
const initProductVariantQuantity = (pid, selector, selectedUnit = null) => {
    if (pid) {
        initVueQuantityComponent(`${selector || ""} .product-qty-vue[data-pid="${pid}"]`, selectedUnit);
    }
};

export { initProductQuantity, initProductVariantQuantity };
